import { css } from 'styled-components';
import paper_small from '../../asset/paper_small.png';
import paper_1 from '../../asset/paper_1.png';
import paper_2 from '../../asset/paper_2.png';
import paper_background from '../../asset/paper_background.png';

/** App.tsx 전체 배경용 이미지 URL */
export const paperBackgroundUrl = paper_background;

/**
 * 종이 질감 base: 공통 스타일 + ::before(이미지).
 * variant는 이 base를 활용해 정의한다.
 */
const paperTextureBase = (paperUrl: string) => css`
  border: 0.5px solid ${({ theme }) => theme.colors.color_Gray_05};
  box-shadow:
    inset 1px 1px 3px 0 rgba(255, 255, 255, 0.35),
    inset -1px -1px 3px 0 rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(8px);
  background-color: ${({ theme }) => theme.colors.color_Alpha_04};
  border-radius: 1px;
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url(${paperUrl});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    opacity: 0.4;
    z-index: -1;
    border-radius: inherit;
    pointer-events: none;
  }
`;

/** 버튼·플로팅 아일랜드용 (paper_small) */
export const paperTextureSmall = paperTextureBase(paper_small);

/** standardAlert용 (paper_1) */
export const paperTextureAlert = paperTextureBase(paper_1);

/** 대부분의 모달용 (paper_2) */
export const paperTextureModal = paperTextureBase(paper_2);

/** 기존 호환: paperTextureBefore = 모달용과 동일 */
export const paperTextureBefore = paperTextureModal;

/**
 * 모바일용 (paper_2).
 * base 대비 차이:
 * - border-radius: 상단만 둥글게 14px 14px 0 0 (하단 직각)
 * - border: 상단만 표시 (좌·우·하단 none)
 * - background-color: color_Alpha_05 (조금 더 불투명)
 */
export const paperTextureMobile = css`
  ${paperTextureBase(paper_2)}
  border-radius: 14px 14px 0 0;
  border-bottom: none;
  border-left: none;
  border-right: none;
  background-color: ${({ theme }) => theme.colors.color_Alpha_05};
`;
